/* eslint-disable @typescript-eslint/no-explicit-any */
import { User, SaveUser } from 'model/user';
import { UserDto, SaveUserDto } from './UserDtos';

/**
 * Convert User DTO to User Model
 * Converts from snake_case (API format) to camelCase (domain model)
 */
export const convertToUser = (dto: UserDto): User => {
    return {
        id: dto.id!,
        orgAccessLevelId: dto.org_access_level_id,
        firstName: dto.first_name,
        lastName: dto.last_name,
        email: dto.email,
        password: dto.password,
        passwordConfirmation: dto.password_confirmation,
        phone: dto.phone,
        emailOptout: dto.email_optout,
        admin: dto.admin,
        active: dto.active,
        marketplaceId: dto.marketplace_id
    };
};

/**
 * Convert User Model to SaveUserDto
 * Converts from camelCase (domain model) to snake_case (API format)
 */
export const convertToSaveUserDto = (user: SaveUser): SaveUserDto => {
    return {
        user: {
            id: user.user.id,
            org_access_level_id: user.user.orgAccessLevelId,
            first_name: user.user.firstName,
            last_name: user.user.lastName,
            email: user.user.email,
            password: user.user.password,
            password_confirmation: user.user.passwordConfirmation,
            phone: user.user.phone,
            email_optout: user.user.emailOptout,
            admin: user.user.admin,
            active: user.user.active,
            marketplace_id: user.user.marketplace_id
        }
    };
};
